import { useEffect, useState } from 'react';
import { usePost, useGet } from 'hooks';
import { Button, Loader } from 'components/common';
import PasswordChange from '../Reset/PasswordChange';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { completeReset, verifyResetPasswordToken } from 'services/api';
import { Alert } from 'antd';
import React from 'react';

const NewPassword = styled.div`
  display: flex;
  flex-direction: column;
`;

const SetNewPass = ({ code }) => {
  const [serverError, setServerError] = useState(null);
  const [passwordSecurityError, setPasswordSecurityError] = useState(null);
  const { push } = useHistory();

  const expiredCodeMessage = (
    <span>
      This link has expired.{' '}
      <a href='/reset'>Click here to restart the process.</a>
    </span>
  );

  const [{ res: codeIsValid, loading: verificationLoading }] = useGet({
    url: verifyResetPasswordToken(code),
    onMount: true,
  });

  const handleResetPassword = () => {
    push('/reset');
  };
  const handleLogin = () => {
    push('/login');
  };

  const [newPass, setNewPass] = useState('');
  const [
    hasClientSidePasswordErrors,
    setHasClientSidePasswordErrors,
  ] = useState(false);

  const [confirmPass, setConfirmPass] = useState('');

  const [{ res, loading, error }, postReset] = usePost({
    url: completeReset,
  });

  const handleReset = () => {
    setServerError(null);
    setPasswordSecurityError(null);
    if (!hasClientSidePasswordErrors) {
      postReset({ code, password: newPass });
    }
  };

  useEffect(() => {
    if (error) {
      setServerError(error);
    }
  }, [error]);

  useEffect(() => {
    setServerError(null);
    setPasswordSecurityError(null);
  }, [newPass, setServerError, setPasswordSecurityError]);

  if (res) {
    return (
      <NewPassword>
        <p>Your password was set successfully.</p>
        <Button onClick={handleLogin}>Go to Login</Button>
      </NewPassword>
    );
  }
  return (
    <React.Fragment>
      {code && !verificationLoading && codeIsValid && (
        <PasswordChange
          serverError={serverError}
          passwordSecurityError={passwordSecurityError}
          newPass={newPass}
          loading={loading}
          setNewPass={setNewPass}
          onChange={setHasClientSidePasswordErrors}
          handleSubmit={handleReset}
          setPasswordSecurityError={setPasswordSecurityError}
          confirmPass={confirmPass}
          setConfirmPass={setConfirmPass}
        />
      )}
      {!codeIsValid && !verificationLoading && (
        <Alert message={expiredCodeMessage} type='error' />
      )}
      {!codeIsValid && !verificationLoading && (
        <Button onClick={handleResetPassword}>Go To Reset Password</Button>
      )}
      {verificationLoading && <Loader />}
    </React.Fragment>
  );
};

export default SetNewPass;
